'use client';

import { createContext } from 'react';

import type { CalendarRootContextInterface } from '../types/calendar-root.types';

export const CalendarRootContext = createContext<CalendarRootContextInterface>({});

CalendarRootContext.displayName = 'Calendar.Root.Context';
